import { useMemo, type CSSProperties } from 'react';

import type { ZoneMetrics } from '../../../shared/dashboard-data';
import { formatArea, formatLengthKm } from '../../utils/formatters';

interface RegionOverviewProps {
  zones: ZoneMetrics[];
}

export function RegionOverview({ zones }: RegionOverviewProps) {
  const sortedZones = useMemo(
    () => [...zones].sort((a, b) => a.order - b.order || a.zoneName.localeCompare(b.zoneName, 'zh-CN')),
    [zones],
  );

  return (
    <ul className="zone-list">
      {sortedZones.map((zone, index) => (
        <li key={zone.zoneId} className={`zone-row ${zone.isMock ? '' : 'is-real'}`}>
          <span className="zone-name">
            <span
              className="zone-dot"
              style={{ '--dot-color': `hsl(${170 - index * 14}deg 72% 60%)` } as CSSProperties}
            />
            {zone.displayName}
          </span>

          <span className="zone-values">
            {formatArea(zone.areaM2)} ㎡ / {formatLengthKm(zone.shapeLengthKm)} km
          </span>
        </li>
      ))}
    </ul>
  );
}
